import * as React from 'react';
import { UitkErrorSummary } from 'uitk-react-error-summary';

interface AskAQuestionResultProps {
  success: boolean;
  message: string;
  action?: string;
  linkClickFocusId?: string;
}

export const AskAQuestionResult: React.FunctionComponent<AskAQuestionResultProps> = ({ success, message, action, linkClickFocusId }) => (
  <React.Fragment>
    {message && (
      <div className="all-t-padding-four all-b-padding-two">
        {!success && <UitkErrorSummary heading={message} link={action} linkClickFocusId={linkClickFocusId} linkClickFocus={{}} />}
        {success && (
          <React.Fragment>
            <h3 className="uitk-type-heading-400">{message}</h3>
            {action && <p className="uitk-type-300">{action}</p>}
          </React.Fragment>
        )}
      </div>
    )}
  </React.Fragment>
);

AskAQuestionResult.displayName = 'AskAQuestionResult';
